import { useMemo } from "react";

import { useViewDataConverter } from "./converter";

import type * as Repository from "./repository";
import type * as Type from "./type";

type QueryData = Repository.Query.QueryData.ReservationListQueryData;
type ViewData = Type.ViewData;

type Props = {
	// チェックイン日での検索
	reservationListByCInDateQueryData: QueryData;
	// チェックアウト日での検索
	reservationListByCOutDateQueryData: QueryData;
	// 宿泊日での検索
	reservationListByStayDateQueryData: QueryData;
	searchModel: Type.SearchModel;
};
type Result = {
	viewData: ViewData;
};

export const useViewData = ({
	reservationListByCInDateQueryData,
	reservationListByCOutDateQueryData,
	reservationListByStayDateQueryData,
	searchModel,
}: Props): Result => {
	const { onConvertViewData } = useViewDataConverter();

	/**
	 * ViewData の取得
	 */
	const viewData = useMemo((): ViewData => {
		/**
		 * viewData への変換
		 */
		const { viewData } = onConvertViewData({
			reservationListByCInDateQueryData,
			reservationListByCOutDateQueryData,
			reservationListByStayDateQueryData,
			searchModel,
		});
		return viewData;
	}, [
		onConvertViewData,
		reservationListByCInDateQueryData,
		reservationListByCOutDateQueryData,
		reservationListByStayDateQueryData,
		searchModel,
	]);

	return {
		viewData,
	};
};
